import { DatumItem, Result } from '../../helper/models/getProducts'
import { addToCart } from '../../helper/services/cart'
import { ImageProcess } from '../../helper/services/imageProcess'

const imageProcess = new ImageProcess()
const ProductList = ({ result, func }: { result: Result; func: Function }) => {
  let groupId = ''
  result.group.map((item) => (groupId = groupId + item.objectId))
  return (
    <div key={result.cuisines}>
      {result.data.map((e) => (
        <div className="flex-wrap grid-flow-col" key={e.category_id}>
          {e.items.map((item) => (
            <div
              className="inline-grid overflow-hidden"
              style={{ width: '50%' }}
              key={item.objectId}
            >
              <div className="p-3 mt-3 mr-3 rounded-lg bg-slate-800">
                <div className="flex">
                  <img
                    src={imageProcess.process(item.images[0])}
                    alt={item.name}
                    key={item.name}
                    className="inline-block rounded-lg w-14 h-14"
                  />
                  <div className="inline-block pl-2">{item.name}</div>
                </div>
                <div className="w-full my-1 overflow-clip text-clip">
                  <p>{item.details}</p>
                </div>
                <div
                  className="w-6 h-6 text-center rounded-full cursor-pointer bg-cyan-600"
                  onClick={(e) => addToCartX(item, result._id, groupId)}
                >
                  <p>+</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  )

  function addToCartX(item: DatumItem, restaurantId: string, groupId: string) {
    addtocart.add(item, restaurantId, groupId)
    func()
  }
}
const addtocart = addToCart

export default ProductList
